import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import {
  InputWrapper,
  InputLabel,
  InputContainer,
  StyledInput,
  InputIcon,
  TogglePasswordButton,
  ErrorMessage,
  HelperText,
} from './Input.styles';

const Input = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  helperText,
  leftIcon,
  rightIcon,
  disabled = false,
  required = false,
  fullWidth = true,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordType = type === 'password';
  const inputType = isPasswordType && showPassword ? 'text' : type;

  return (
    <InputWrapper fullWidth={fullWidth}>
      {label && (
        <InputLabel>
          {label}
          {required && <span style={{ color: 'red' }}> *</span>}
        </InputLabel>
      )}
      
      <InputContainer error={error} disabled={disabled}>
        {leftIcon && <InputIcon position="left">{leftIcon}</InputIcon>}
        
        <StyledInput
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          hasLeftIcon={!!leftIcon}
          hasRightIcon={!!rightIcon || isPasswordType}
          {...props}
        />
        
        {isPasswordType && (
          <TogglePasswordButton
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </TogglePasswordButton>
        )}
        
        {rightIcon && !isPasswordType && (
          <InputIcon position="right">{rightIcon}</InputIcon>
        )}
      </InputContainer>
      
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {helperText && !error && <HelperText>{helperText}</HelperText>}
    </InputWrapper>
  );
};

export default Input;

